export const LINKS = {
  instagram: "https://www.instagram.com/sipsation.bh",
  talabat: "https://www.talabat.com/bahrain/sipsation",
  whatsapp: "https://wa.me/97333888070?text=Hello%20Sipsation!%20I%27d%20like%20to%20place%20an%20order.",
  phone: "tel:+97377779990",
  maps: "https://www.google.com/maps/search/?api=1&query=Sipsation+Coffee+Bahrain",
};

export const IMG = {
  hero: "https://customer-assets-lxgj4vgw.emergentagent.net/job_daily-brew-63/artifacts/6s41del6_image.png",
  terrace: "https://customer-assets-lxgj4vgw.emergentagent.net/job_daily-brew-63/artifacts/rqxipfmb_image.png",
  lattes: "https://customer-assets-lxgj4vgw.emergentagent.net/job_daily-brew-63/artifacts/lah9yput_image.png",
  waffle: "https://customer-assets-lxgj4vgw.emergentagent.net/job_daily-brew-63/artifacts/ea52ok94_image.png",
  interior: "https://customer-assets-lxgj4vgw.emergentagent.net/job_daily-brew-63/artifacts/qwyc6nm7_image.png",
  chess: "https://customer-assets-lxgj4vgw.emergentagent.net/job_daily-brew-63/artifacts/r7iruc6q_image.png",
};

export const scrollToSection = (selector) => (e) => {
  e?.preventDefault();
  const el = document.querySelector(selector);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
